import { gql } from "@apollo/client";

export const releaseConnectionBulk = gql`
    mutation releaseConnectionBulk($releaseRequests: [InputReleaseConnectionRequest]!) {
        releaseConnectionBulk(input: { releaseRequests: $releaseRequests }) {
            releaseResponses {
                connectionId
                groupId
                lensCompoundId {
                    id
                    lensSourceType
                    reference
                }
            }
        }
    }
`;
